import { Component } from "react";
import { ReactComponent as LoadingIcon } from "../../assets/icons/loading-icon.svg";
import { ReactComponent as Save } from "../../assets/icons/Save.svg";
import { ReactComponent as Warning } from "../../assets/icons/Warning.svg";
import filedownloadService from "app/services/filedownload.service";
import { JobStatusEnum } from "app/models/jobstatus";
import fileDownload from 'js-file-download';
import './filedownload.scss';
import { ButtonIcon } from '@ecosystem/ui-lib/core/components/ButtonIcon';
import { Icons } from '@ecosystem/ui-lib/core/components/Icon';
import jobtrackerService from "app/services/jobtracker.service";
import { GlobalStateContext } from 'app/contexts/GlobalStateContext';

class FileDownloadStatus extends Component {
    static contextType = GlobalStateContext;
    constructor(props){
        super(props);
        this.state = {
            show: false,
            showClose: false,
            jobstatus: null,
            progress: null,
            message: null
        }
    }

    componentDidMount() {
        this.start(this.props.jobId);
    }

    start = (jobid) => {
        this.setState({
            show: true,
            showClose: false,
            progress: "running",
            message: `Generating file 'request-${this.props.fileNumber}'...`
        });
        var monitor = setInterval(async () => {
            var jobStatus = await jobtrackerService.jobStatus(jobid);
            switch (jobStatus.status) {
                case JobStatusEnum.Completed:
                    this.setState({
                        progress: "running",
                        message: `Downloading file 'request-${this.props.fileNumber}'...`
                    });
                    clearInterval(monitor);
                    this.downloadFile(jobid);
                    break;
                case JobStatusEnum.NotFound:
                    this.setState({
                        progress: "failed",
                        message: `Something went wrong with 'request-${this.props.fileNumber}'. Please try again.`,
                        showClose: true
                    });
                    clearInterval(monitor);
                    break;
                case JobStatusEnum.Failed:
                    this.setState({
                        progress: "failed",
                        message: jobStatus.errorMessage,
                        showClose: true
                    });
                    clearInterval(monitor);
                    break;
                case JobStatusEnum.Submitted:
                case JobStatusEnum.Running:
                    this.setState({
                        progress: "running",
                        message: `Generating file 'request-${this.props.fileNumber}'...`
                    });
                    break;
                default:
                    break;
            }
        }, 5000);
    }

    downloadFile(jobid){
        filedownloadService.download(jobid)
        .then(response => {
            let name = response.headers['content-disposition'].split('filename=')[1].split('.')[0];
            let extension = response.headers['content-disposition'].split('.')[1].split(';')[0];		
            let fileName = `${name}.${extension}`;
            fileDownload(response.data, fileName);
            this.setState({
                progress: "completed",
                message:  `Downloaded 'request-${this.props.fileNumber}': '${fileName}'`,
                showClose: true
            });
            const { removeFileDownloadJobId } = this.context;
            removeFileDownloadJobId(jobid);
        })
        .catch((error) => {
            this.setState({
                progress: "failed",
                message: error.message,
                showClose: true
            });
        });
    }

    renderIcon(){
        const { progress } = this.state;

        switch (progress) {
            case "running":
                return <LoadingIcon className="running"/>;
            case "completed":
                return <Save className="completed"/>;
            case "failed":
                return <Warning className="failed"/>;
            default:
                return null;
        }
    }

    render() {
        return(
            <>
            {
                this.state.show && 
                (
                    <div className="file-download-status">
                        <div className="icon">
                            {this.renderIcon()}
                        </div>
                        <div className="message">
                            <span>{this.state.message}</span>
                        </div>
                        {
                            this.state.showClose &&
                            <div className="close-button">
                                <ButtonIcon onClick={() => this.setState({show: false})}  icon={Icons.Close}/>
                            </div>
                        }
                    </div>
                )
            }
            </>
        )                
    }
}

export default FileDownloadStatus;